module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "benefits"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.componentValue),
      expression: "componentValue"
    }],
    domProps: {
      "value": (_vm.componentValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.componentValue = $event.target.value
      }
    }
  }), _vm._v(" " + _vm._s(_vm.componentValue) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-062bfc3e!./src/components/benefits/template.html
// module id = 3517
// module chunks = 1